import { z } from "zod";

export const OTC_LAYER_AMENDMENT_TYPE_VALUES = [
  "split",
  "error_correction",
  "futures_roll",
  "basis_roll",
  "otc_roll",
  "exit",
  "expired",
  "contract_type_change",
  "contract_legs_change",
  "roll",
] as const;

export const OtcLayerAmendmentTypeValidation = z.enum(
  OTC_LAYER_AMENDMENT_TYPE_VALUES,
);

export type OtcLayerAmendmentType = z.infer<
  typeof OtcLayerAmendmentTypeValidation
>;

// NOTE: Not for selecting what amendments you can create
// But rather, if you need to render any type, you can show this
export const OTC_LAYER_AMENDMENT_TYPE_DISPLAY_OPTIONS: {
  value: OtcLayerAmendmentType;
  label: string;
}[] = [
  { value: "split", label: "Split" },
  { value: "error_correction", label: "Error Correction" },
  { value: "futures_roll", label: "Futures Roll" },
  { value: "basis_roll", label: "Basis Roll" },
  { value: "otc_roll", label: "OTC Roll" },
  { value: "exit", label: "Exit" },
  { value: "expired", label: "Expired" },
  { value: "contract_type_change", label: "Contract Type Change" },
  { value: "contract_legs_change", label: "Contract Legs Change" },
  { value: "roll", label: "Roll" },
];

export function getAmendmentTypeDisplay(
  amendmentType: string | null | undefined,
): string {
  if (!amendmentType) return "Initial";

  const option = OTC_LAYER_AMENDMENT_TYPE_DISPLAY_OPTIONS.find(
    (item: { value: OtcLayerAmendmentType; label: string }): boolean =>
      item.value === amendmentType,
  );
  if (option) return option.label;

  return amendmentType
    .split("_")
    .filter((part: string): boolean => part.length > 0)
    .map((part: string): string => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");
}
